module.exports = __webpack_public_path__ + "img/Condominio_das_Americas_Localizacao.ed268e6c.jpg";